namespace GeniuzPOS.Purchase {
    export interface PoParaForm {
        ToleranceTotal: Serenity.DecimalEditor;
        ToleranceVat: Serenity.DecimalEditor;
    }

    export class PoParaForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoParaForm.init)  {
                PoParaForm.init = true;

                var s = Serenity;
                var w0 = s.DecimalEditor;

                Q.initFormType(PoParaForm, [
                    'ToleranceTotal', w0,
                    'ToleranceVat', w0
                ]);
            }
        }
    }
}
